import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { payersApi } from '../api/payersApi';
import { payerKeys, setupKeys } from '../queryKeys';

export function useAddPayerToLocation() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payerId: string) => payersApi.addPayerToLocation(locationId, payerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: payerKeys.list(locationId) });
      queryClient.invalidateQueries({ queryKey: setupKeys.readiness(locationId) });
    },
  });
}

export function useAddPayerManuallyThenAttach() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (name: string) => {
      const payer = await payersApi.addPayerManually(name);
      return payersApi.addPayerToLocation(locationId, payer.id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: payerKeys.list(locationId) });
      queryClient.invalidateQueries({ queryKey: setupKeys.readiness(locationId) });
    },
  });
}
